import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    login: 'Login',
    logout: 'Logout',
    logoutConfirm: 'Are you sure you want to log out?'
};

const hr = {
    login: 'Prijava',
    logout: 'Odjava',
    logoutConfirm: 'Jeste li sigurni da se želite odjaviti?'
};

export const strings: Strings<typeof en> = {en, hr};
